import { type Enum } from '@webapp/infrastructure/types/Enum'

export const IssuingProviders = {
  STRIPE: 0,
  AIRWALLEX: 1,
} as const
export type IssuingProviderEnum = Enum<typeof IssuingProviders>
